<template>
  <div
    v-if="visible"
    class="box-content fixed -translate-x-2/4 bottom-8 left-1/2 z-10 px-[15px] py-[10px] h-[9px] leading-[9px] text-center text-[12px] rounded-[4px] bg-[#000]"
  >
    {{ msg }}
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
const props = defineProps<{
  show: boolean;
  msg: string;
  duration: number;
}>();

const visible = ref(props.show);
const emit = defineEmits(['update:show']);
const timer = ref<NodeJS.Timeout | undefined>(undefined);

watch(
  () => props.show,
  (newVal) => {
    visible.value = newVal;
    if (newVal) {
      clearInterval(timer.value);
      timer.value = setTimeout(() => {
        visible.value = false;
        emit('update:show', false);
      }, props.duration);
    }
  }
);
</script>
